import React from 'react';

// §2 主体 — 头套主体面部 (hood-base-color) · 头盖 (crown-color)
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MainSection({ config, parts }) {
  return (
    <>
<path className={"hood-" + config['hood-base-color']} d={parts['hood-base-color_c'] || ''}/>
<path className={"hood-" + config['crown-color']} d={parts['crown-color_c'] || ''}/>
    </>
  );
}
